export interface IClaims {
	submit_case?: boolean
	soft_claim?: {
		[key: string]: boolean
	}
}

export const createClaims = (props: IClaims = {}): IClaims => ({
	submit_case: props.submit_case || false,
	soft_claim: props.soft_claim ?? {},
})
